import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  createFlashcardAPI,
  getFlashcardAPI,
  getMyFlashcardsAPI,
  getStudentFlashcardsAPI,
  updateFlashcardAPI,
  deleteFlashcardAPI,
  assignFlashcardAPI
} from "../../services/flashcard";

export let createFlashcard = createAsyncThunk(
  "flashcard/create",
  async (flashcardData, thunkApi) => {
    try {
      let response = await createFlashcardAPI(flashcardData);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getFlashcard = createAsyncThunk(
  "flashcard/get",
  async (flashcardId, thunkApi) => {
    try {
      let response = await getFlashcardAPI(flashcardId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getMyFlashcards = createAsyncThunk(
  "flashcard/my",
  async (_, thunkApi) => {
    try {
      let response = await getMyFlashcardsAPI();
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let getStudentFlashcards = createAsyncThunk(
  "flashcard/student",
  async (_, thunkApi) => {
    try {
      let response = await getStudentFlashcardsAPI();
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let updateFlashcard = createAsyncThunk(
  "flashcard/update",
  async ({ flashcardId, flashcardData }, thunkApi) => {
    try {
      let response = await updateFlashcardAPI(flashcardId, flashcardData);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let deleteFlashcard = createAsyncThunk(
  "flashcard/delete",
  async (flashcardId, thunkApi) => {
    try {
      let response = await deleteFlashcardAPI(flashcardId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

export let assignFlashcard = createAsyncThunk(
  "flashcard/assign",
  async ({ flashcardId, studentId }, thunkApi) => {
    try {
      let response = await assignFlashcardAPI(flashcardId, studentId);
      return response.data;
    } catch (error) {
      let errorMsg = error.response?.data?.msg || error.response?.data?.message;
      return thunkApi.rejectWithValue(errorMsg ? errorMsg : error.message);
    }
  }
);

let initialState = {
  loading: false,
  flashcards: [],
  currentFlashcard: null,
  error: null,
  errorMsg: "",
  successMsg: ""
};

let flashcardSlice = createSlice({
  name: "flashcard",
  initialState,
  reducers: {
    clearFlashcard: (state, action) => {
      state.loading = false;
      state.error = null;
      state.errorMsg = "";
      state.successMsg = "";
    },
    setCurrentFlashcard: (state, action) => {
      state.currentFlashcard = action.payload;
    }
  },
  extraReducers: {
    [createFlashcard.pending]: (state, action) => {
      state.loading = true;
    },
    [createFlashcard.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentFlashcard = action.payload.flashcard;
      state.successMsg = "Flashcard created successfully";
    },
    [createFlashcard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to create flashcard";
    },
    [getFlashcard.pending]: (state, action) => {
      state.loading = true;
    },
    [getFlashcard.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentFlashcard = action.payload.flashcard;
    },
    [getFlashcard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getMyFlashcards.pending]: (state, action) => {
      state.loading = true;
    },
    [getMyFlashcards.fulfilled]: (state, action) => {
      state.loading = false;
      state.flashcards = action.payload.flashcards;
    },
    [getMyFlashcards.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [getStudentFlashcards.pending]: (state, action) => {
      state.loading = true;
    },
    [getStudentFlashcards.fulfilled]: (state, action) => {
      state.loading = false;
      state.flashcards = action.payload.flashcards;
    },
    [getStudentFlashcards.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    },
    [updateFlashcard.pending]: (state, action) => {
      state.loading = true;
    },
    [updateFlashcard.fulfilled]: (state, action) => {
      state.loading = false;
      state.currentFlashcard = action.payload.flashcard;
      state.successMsg = "Flashcard updated successfully";
    },
    [updateFlashcard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to update flashcard";
    },
    [deleteFlashcard.pending]: (state, action) => {
      state.loading = true;
    },
    [deleteFlashcard.fulfilled]: (state, action) => {
      state.loading = false;
      state.successMsg = "Flashcard deleted successfully";
    },
    [deleteFlashcard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to delete flashcard";
    },
    [assignFlashcard.pending]: (state, action) => {
      state.loading = true;
    },
    [assignFlashcard.fulfilled]: (state, action) => {
      state.loading = false;
      state.successMsg = "Flashcard assigned successfully";
    },
    [assignFlashcard.rejected]: (state, action) => {
      state.loading = false;
      state.error = action.payload;
      state.errorMsg = "Failed to assign flashcard";
    }
  }
});

let flashcardReducer = flashcardSlice.reducer;
export let { clearFlashcard, setCurrentFlashcard } = flashcardSlice.actions;
export default flashcardReducer;

